<template>
  <div class="d-flex flex-column flex-root">
    <!--begin::Page-->
    <div class="page d-flex flex-row flex-column-fluid">
      <!--begin::Aside-->
      <!--end::Aside-->
      <!--begin::Wrapper-->
      <div class="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
        <!--begin::Header-->
        <div id="kt_header" class="header">
          <!--begin::Container-->
          <div
              class="container-fluid d-flex align-items-center flex-wrap justify-content-between"
              id="kt_header_container"
          >
            <!--begin::Page title-->
            <div
                class="page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-2 pb-5 pb-lg-0 pt-7 pt-lg-0"
                data-kt-swapper="true"
                data-kt-swapper-mode="prepend"
                data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}"
            >
              <!--begin::Heading-->
              <h1 class="d-flex flex-column text-dark fw-bolder my-0">
                Dashboard
              </h1>
              <!--end::Heading-->
            </div>
            <!--end::Page title=-->
            <!--begin::Wrapper-->
            <div class="d-flex d-lg-none align-items-center ms-n3 me-2">
              <!--begin::Aside mobile toggle-->
              <div
                  class="btn btn-icon btn-active-icon-primary"
                  id="kt_aside_toggle"
              >
                <!--begin::Svg Icon | path: icons/duotune/abstract/abs015.svg-->
                <span class="svg-icon svg-icon-1 mt-1">
                  <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                  >
                    <path
                        d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                        fill="black"
                    />
                    <path
                        opacity="0.3"
                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                        fill="black"
                    />
                  </svg>
                </span>
                <!--end::Svg Icon-->
              </div>
              <!--end::Aside mobile toggle-->
              <!--begin::Logo-->
              <a
                  href="../../demo15/dist/index.html"
                  class="d-flex align-items-center"
              >
                <img
                    alt="Logo"
                    src="../assets/media/logos/logo-2.svg"
                    class="h-30px"
                />
              </a>
              <!--end::Logo-->
            </div>
          </div>
          <!--end::Container-->
        </div>
        <!--end::Header-->
        <!--begin::Content-->
        <div
            class="content d-flex flex-column flex-column-fluid"
            id="kt_content"
        >
          <!--begin::Container-->
          <div class="container-fluid" id="kt_content_container">
            <!--begin::Row-->
            <div class="row">
              <div class="col-12 my-3">
                <div class="row">
                  <div class="col-md-1 col-3">
                    <img
                        class="me-1"
                        style="width: 18px"
                        src="/assets/images/profile-user.png"
                        alt=""
                    />
                    {{ $numberFormat((countUserOnline.WEB || 0) + (countUserOnline.IOS || 0) + (countUserOnline.ANDROID || 0)) }}
                  </div>
                  <div class="col-md-1 col-3">
                    <img
                        class="me-1"
                        style="width: 18px"
                        src="/assets/images/web.png"
                        alt=""
                    />
                    {{ $numberFormat(countUserOnline.WEB || 0) }}
                  </div>
                  <div class="col-md-1 col-3">
                    <img
                        class="me-1"
                        style="width: 18px"
                        src="/assets/images/apple.png"
                        alt=""
                    />
                    {{ $numberFormat(countUserOnline.IOS || 0) }}
                  </div>
                  <div class="col-md-1 col-3">
                    <img
                        class="me-1"
                        style="width: 18px"
                        src="/assets/images/social.png"
                        alt=""
                    />
                    {{ $numberFormat(countUserOnline.ANDROID || 0) }}
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 my-3" v-if="viewStatLoading">
                <div class="spinner-border text-dark" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="spinner-border text-dark mx-4" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="spinner-border text-dark" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="row px-1">
                  <div class="col-12 col-md-6 " v-for="item in viewStats" v-bind:key="item.day">
                    <div class="card p-3">
                      <div :key="item.date" class="fw-bold">Ngày {{item.date[2]}}/{{item.date[1]}}/{{item.date[0]}}</div>
                      <div class="card-body row px-0">
                        <div v-for="i in item.stats" class="col-6 " v-bind:key="i.cookieId">
                          <div class="my-1">
                            <div class="card bg-secondary p-2">
                              <div>Cookie: {{i.cookieId}}</div>
                              <div>UserId: {{i.userId}}</div>
                              <div>Count: {{i.count}}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row g-5 g-lg-10">
              <b-tabs content-class="mt-3">
                <b-tab title="Tổng quan" active>
                  <div class="row">
                    <div
                        class="col-xxl-3 col-md-4 mb-xxl-10"
                        v-for="(item, index) in this.items"
                        :key="index"
                    >
                      <!--begin::Mixed Widget 17-->
                      <div class="card h-md-100">
                        <!--begin::Body-->
                        <div class="card-body pt-5">
                          <!--begin::Heading-->
                          <div class="d-flex flex-stack">
                            <!--begin::Title-->
                            <h4 class="fw-bolder text-gray-800 m-0 mb-5">
                              Ngày {{ item.id }}
                            </h4>
                            <!--end::Title-->
                            <!--begin::Menu-->
                          </div>
                          <!--end::Heading-->
                          <!--begin::Chart-->
                          <div class="d-flexw-100">
                            <div v-for="field in fields" :key="field.key">
                              <b>{{ field.title }}</b> :
                              <span
                                  @click="copyValue(item[field.key])"
                                  class="copyable"
                              >
                          {{
                                  field.format
                                      ? $numberFormat(item[field.key])
                                      : item[field.key]
                                }}
                        </span>
                              <em class="small" v-if="index + 1 < items.length">
                                <template
                                    v-if="
                              item[field.key] - items[index + 1][field.key] > 0
                            "
                                >
                                  <b class="text-success">
                                    <i class="bi bi-caret-up-fill text-success"></i>
                                    {{
                                      field.format
                                          ? $numberFormat(
                                              item[field.key] -
                                              items[index + 1][field.key]
                                          )
                                          : item[field.key] -
                                          items[index + 1][field.key]
                                    }}
                                  </b>
                                </template>
                                <template
                                    v-else-if="
                              item[field.key] - items[index + 1][field.key] < 0
                            "
                                >
                                  <b class="text-danger">
                                    <i class="bi bi-caret-down-fill text-danger"></i>
                                    {{
                                      field.format
                                          ? $numberFormat(
                                              Math.abs(
                                                  item[field.key] -
                                                  items[index + 1][field.key]
                                              )
                                          )
                                          : Math.abs(
                                              item[field.key] -
                                              items[index + 1][field.key]
                                          )
                                    }}
                                  </b>
                                </template>
                                <!-- bằng 0 thì không hiển thị gì -->
                              </em>
                              <br/>
                            </div>
                          </div>
                          <!--end::Chart-->
                        </div>
                        <!--end::Body-->
                      </div>
                      <!--end::Mixed Widget 17-->
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Người dùng">
                  <div class="row">
                    <div
                        class="col-xxl-3 col-md-4 mb-xxl-10"
                        v-for="(item, index) in this.items"
                        :key="index"
                    >
                      <!--begin::Mixed Widget 17-->
                      <div class="card h-md-100">
                        <!--begin::Body-->
                        <div class="card-body pt-5">
                          <!--begin::Heading-->
                          <div class="d-flex flex-stack">
                            <!--begin::Title-->
                            <h4 class="fw-bolder text-gray-800 m-0 mb-5">
                              Ngày {{ item.id }}
                            </h4>
                            <!--end::Title-->
                            <!--begin::Menu-->
                          </div>
                          <!--end::Heading-->
                          <!--begin::Chart-->
                          <div class="d-flexw-100">
                            <div>Tổng : <b>{{ $numberFormat(item.totalVisitors) }} </b></div>
                            <div>Tổng web: <b>
                              {{ $numberFormat(item.totalWebVisitors) }}
                            </b>
                              ({{ (item.totalWebVisitors * 100 / item.totalVisitors).toFixed(2) }}%)
                            </div>
                            <div>Tổng iOS : <b>{{ $numberFormat(item.totalIOSVisitors) }}
                            </b>({{ (item.totalIOSVisitors * 100 / item.totalVisitors).toFixed(2) }}%)
                            </div>
                            <div>Tổng Android : <b>{{ $numberFormat(item.totalAndroidVisitors) }}
                            </b>({{ (item.totalAndroidVisitors * 100 / item.totalVisitors).toFixed(2) }}%)
                            </div>
                          </div>
                          <!--end::Chart-->
                        </div>
                        <!--end::Body-->
                      </div>
                      <!--end::Mixed Widget 17-->
                    </div>
                  </div>
                </b-tab>
                <b-tab title="Lượt đọc">
                  <div class="row">
                    <div
                        class="col-xxl-3 col-md-4 mb-xxl-10"
                        v-for="(item, index) in this.items"
                        :key="index"
                    >
                      <!--begin::Mixed Widget 17-->
                      <div class="card h-md-100">
                        <!--begin::Body-->
                        <div class="card-body pt-5">
                          <!--begin::Heading-->
                          <div class="d-flex flex-stack">
                            <!--begin::Title-->
                            <h4 class="fw-bolder text-gray-800 m-0 mb-5">
                              Ngày {{ item.id }}
                            </h4>
                            <!--end::Title-->
                            <!--begin::Menu-->
                          </div>
                          <!--end::Heading-->
                          <!--begin::Chart-->
                          <div class="d-flexw-100">
                            <div>Tổng : <b>{{ $numberFormat(item.countView + item.countViewNotPay) }} </b></div>
                            <div>Tổng web: <b>
                              {{ $numberFormat(item.totalWebViews) }}
                            </b>
                              ({{ (item.totalWebViews * 100 / (item.countView + item.countViewNotPay)).toFixed(2) }}%)
                            </div>
                            <div>Tổng iOS : <b>{{ $numberFormat(item.totalIOSViews) }}
                            </b>({{ (item.totalIOSViews * 100 / (item.countView + item.countViewNotPay)).toFixed(2) }}%)
                            </div>
                            <div>Tổng Android : <b>{{ $numberFormat(item.totalAndroidViews) }}
                            </b>({{ (item.totalAndroidViews * 100 / (item.countView + item.countViewNotPay)).toFixed(2) }}%)
                            </div>
                          </div>
                          <!--end::Chart-->
                        </div>
                        <!--end::Body-->
                      </div>
                      <!--end::Mixed Widget 17-->
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
              <!--end::Col-->
            </div>
            <div class="row">
              <div class="col-12 my-3" v-if="reportLoading">
                <div class="spinner-border text-dark" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="spinner-border text-dark mx-4" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div class="spinner-border text-dark" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </div>
              <div v-else>
                <div class="row px-1">
                  <div class="col-12 col-md-6 " v-for="report in reports" v-bind:key="report.month">
                    <div class="card p-3">
                      <div :key="report.month" class="fw-bold">Tháng {{report.month}}</div>
                      <div class="card-body">
                        <div v-for="i in report.items" v-bind:key="i.key">
                          <div class=" my-1"><label class="fw-bold">{{i.label}} : </label><span class="ms-3">{{$numberFormat(i.value)}}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::Container-->
        </div>
        <!--end::Content-->
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Page-->
  </div>
</template>

<script>
import requestUtil from "@/utils/request-util";

export default {
  name: "DashboardPage",
  props: {
    msg: String,
  },
  components: {},
  data() {
    return {
      items: [],
      reports: [],
      viewStats: [],
      reportLoading: true,
      viewStatLoading: true,
      countUserOnline: {},
      fields: [
        {title: "Người dùng", key: "countUser", format: true},
        {title: "Tổng người dùng", key: "totalUser", format: true},
        {title: "Tổng Premium", key: "totalUserPremium", format: true},
        {title: "Tác giả", key: "countAuthor", format: true},
        {title: "Truyện", key: "countStory", format: true},
        {title: "Chương", key: "countChapter", format: true},
        {title: "Lượt đọc trả xu", key: "countView", format: true},
        {
          title: "Lượt đọc không trả xu",
          key: "countViewNotPay",
          format: true,
        },
        {title: "Bình luận", key: "countComment", format: true},
        {title: "Đánh dấu", key: "countFavorite", format: true},
        {title: "Lượt cảm xúc", key: "countReact", format: true},
        {title: "Lượt donate", key: "countDonate", format: true},
        {title: "Lượt mua", key: "countOrder", format: true},
        {title: "Lượt Follow", key: "countFollow", format: true},
        {title: "Số lần nạp", key: "countWalletRequest", format: true},
        {title: "Xu nạp", key: "sumAmountRecharge", format: true},
        {title: "Xu donate", key: "sumAmountDonate", format: true},
        {
          title: "Xu thưởng lượt đọc",
          key: "sumAmountAwardByDay",
          format: true,
        },
        {title: "Xu lượt đọc", key: "sumAmountViewByDay", format: true},
        {
          title: "Xu truyện của tuần",
          key: "sumAmountStoryOfWeek",
          format: true,
        },
        {
          title: "Xu tác giả của tháng",
          key: "sumAmountAuthorOfMonth",
          format: true,
        },
        {title: "Tổng xu", key: "sumAmountByDay", format: true},
      ],
    };
  },
  computed: {},
  methods: {
    copyValue(value) {
      // Nếu format là string, bỏ dấu ngăn cách nếu cần
      navigator.clipboard.writeText(value).then(() => {
        this.$notify({
          text: "Đã copy vào clipboard!",
          type: "success",
        });
      });
    },
    async fetchItems() {
      try {
        // Gọi API để lấy dữ liệu
        const response = await requestUtil.get(
            "/admin/statsByDay?sort=id,desc&size=4",
            this.filter
        );

        if (response.status === 200) {
          // Cập nhật categories từ API
          this.items = response.data.data;
        } else {
          this.$notify({
            title: "Có lỗi xảy ra",
            type: "warn",
          });
        }
      } catch (error) {
        this.$notify({
          title: "Lỗi kết nối",
          type: "error",
        });
      }
    },
    async fetchReport() {
      try {
        // Gọi API để lấy dữ liệu
        const response = await requestUtil.get(
            "/admin/report/financial?size=2"
        );
        if (response.status === 200) {
          // Cập nhật categories từ API
          this.reports = response.data;
        } else {
          this.$notify({
            title: "Có lỗi xảy ra",
            type: "warn",
          });
        }
      } catch (error) {
        this.$notify({
          title: "Lỗi kết nối",
          type: "error",
        });
      }
      this.reportLoading = false;
    },
    async fetchViewStats() {
      this.viewStatLoading = true;
      try {
        // Gọi API để lấy dữ liệu
        const response = await requestUtil.get(
            "/view/stats/_user?days=2"
        );
        if (response.status === 200) {
          // Cập nhật categories từ API
          this.viewStats = response.data;
        } else {
          this.$notify({
            title: "Có lỗi xảy ra",
            type: "warn",
          });
        }
      } catch (error) {
        this.$notify({
          title: "Lỗi kết nối",
          type: "error",
        });
      }
      this.viewStatLoading = false;
    },
  },
  watch: {},
  mounted() {
    this.fetchItems();
    this.fetchReport();
    this.fetchViewStats();
  },
  created() {
    // Lắng nghe sự kiện 'message' từ server
    this.$socket.on('connections:update', (data) => {
      this.countUserOnline = data;
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
